<template>
<v-app>
  <v-content>

    <v-container fluid>
        <h1>Desktop Software</h1>
        <v-divider></v-divider>
        <h3 class='headline'>Monitor Discovery tool</h3>
         <v-btn @click='downloadFile(config.webconfig.desktopMonitorApp)' rounded color="primary" dark>Download</v-btn>
          <p class='red--text'>Speical Monitor WMI class installer (required to use Monitor Disocvery tool)</p>
           <v-btn @click='downloadFile(config.webconfig.monitorWMIclass)' rounded color="primary" dark>Download</v-btn>
          <h3 class='headline'>Computer Discovery tool</h3>
         <v-btn @click='downloadFile(config.webconfig.desktopApp)' rounded color="primary" dark>Download</v-btn>
        
         <h1 class='pt-5'>Server Files</h1>
          <v-divider></v-divider>
         <h3 class='headline'>PXE server</h3>
          <v-btn @click='downloadFile(config.webconfig.pxeserver)' rounded color="primary" dark>Download</v-btn>
         <h1 class='pt-5'>Images Files</h1>
          <v-divider></v-divider>
         <h3 class='headline'>ISO File</h3>
         <v-btn @click='downloadFile(config.webconfig.iso32)' rounded color="primary" dark>Download 32bit version</v-btn>
         <v-btn @click='downloadFile(config.webconfig.iso)' rounded color="primary" dark>Download 64bit version</v-btn>
          <h3 class='headline'>Wim File</h3>
          <v-btn @click='downloadFile(config.webconfig.bootwim32)' rounded color="primary" dark>Download 32bit version</v-btn>
         <v-btn @click='downloadFile(config.webconfig.bootwim)' rounded color="primary" dark>Download 64bit version</v-btn>
         
    </v-container>
  </v-content>

</v-app>
    
      
</template>

<script>
import config from "../firebaseIDs";
const fb = require("../firebaseConfig");
export default {
      data: () => ({
    config: config,
  }),
    methods : {
    downloadFile (url) {
    var gsReference = fb.storage.refFromURL(
        url
      );
      gsReference.getDownloadURL().then(url => {
        window.open(url, "_blank");
      });
    },
    }
}
</script>

<style>

</style>